import { client } from './client';
import type { ApiResponse } from '@/types/api';
import type {
  TeacherListItem,
  TeacherDetailResponse,
  AssignStudentInput,
  StudentSearchItem,
} from '@/types/admin';

interface PaginatedResponse<T> {
  data: T;
  pagination: {
    page: number;
    per_page: number;
    total: number;
    total_pages: number;
  };
}

export async function listTeachers(
  page = 1,
  perPage = 20,
): Promise<PaginatedResponse<TeacherListItem[]>> {
  const { data } = await client.get<PaginatedResponse<TeacherListItem[]>>(
    '/api/v1/admin/teachers',
    { params: { page, per_page: perPage } },
  );
  return data;
}

export async function getTeacherDetail(
  id: string,
): Promise<TeacherDetailResponse> {
  const { data } = await client.get<ApiResponse<TeacherDetailResponse>>(
    `/api/v1/admin/teachers/${id}`,
  );
  return data.data;
}

export async function assignStudent(
  teacherID: string,
  input: AssignStudentInput,
): Promise<void> {
  await client.post(`/api/v1/admin/teachers/${teacherID}/assign-student`, input);
}

export async function searchStudents(
  search: string,
  limit = 20,
): Promise<StudentSearchItem[]> {
  const { data } = await client.get<ApiResponse<StudentSearchItem[]>>(
    '/api/v1/admin/students',
    { params: { search, limit } },
  );
  return data.data;
}

export async function searchTeachers(
  search: string,
  limit = 20,
): Promise<StudentSearchItem[]> {
  const { data } = await client.get<ApiResponse<StudentSearchItem[]>>(
    '/api/v1/admin/teachers/search',
    { params: { search, limit } },
  );
  return data.data;
}

export async function removeStudentFromTeacher(
  teacherID: string,
  studentID: string,
): Promise<void> {
  await client.delete(
    `/api/v1/admin/teachers/${teacherID}/students/${studentID}`,
  );
}
